module.exports = __webpack_public_path__ + "img/guzhi.24f01c09.png";